module.exports = __webpack_public_path__ + "img/feizaojun.a1d57ba0.jpg";